import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { applySession } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then((r) => {
        applySession(r.data.token, r.data.user);
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { replace: true });
      })
      .catch(() => nav("/login", { replace: true }));
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f2f0eb]">
      <div className="label-tech animate-pulse">Signing you in…</div>
    </div>
  );
}
